import React, { useEffect, useState } from "react";
import {
    SovosAlert,
    SovosAlertTitle,
    SovosBox,
    SovosButton,
    SovosDialogContent,
    SovosEditableDrawer,
    SovosFilterTextEntry,
    SovosIconButton,
    SovosTextField,
    SovosTypography,
} from "mosaic-react";
import { Add, Delete } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { onTranslationTableDetailsSave } from "./utils";

const conditionsUpdateBuild = (values, cdmNames, setter) => {
    return (values || []).map((elem, index) => {
        const { column, operator, value } = elem;
        const columnName = column.split(".");
        return (
            <SovosBox
                key={index}
                sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                <SovosFilterTextEntry
                    label={"Column"}
                    data={[columnName[columnName.length - 1]]}
                    AutocompleteProps={{
                        loading: cdmNames?.length === 0,
                        options: cdmNames || [],
                        getOptionLabel: (option) => {
                            const optionName = option.split(".");
                            return optionName[optionName.length - 1];
                        },
                        isOptionEqualToValue: (option, value) => {
                            const optionName = option.split(".");
                            return optionName[optionName.length - 1] === value;
                        },
                        variant: "standard",
                        noOptionsText: `Field not available in the entity`,
                    }}
                    onChange={(e) => {
                        const [eventValue] = e;
                        setter((prevItems) => {
                            return prevItems.map((item, i) =>
                                i === index ? { ...item, column: eventValue.split(".")[1] } : item,
                            );
                        });
                    }}
                />
                <SovosTypography children={operator} variant={"span"} sx={{ margin: "10px" }} />
                <SovosTextField
                    helperText="value"
                    onChange={(e) => {
                        const value = e.target.value;
                        setter((prevItems) => {
                            return prevItems.map((item, i) =>
                                i === index ? { ...item, value } : item,
                            );
                        });
                    }}
                    placeholder="Start typing"
                    value={value}
                />
                <SovosIconButton
                    sx={{ marginLeft: "10px" }}
                    tooltipText={"Delete entry"}
                    onClick={() => {
                        setter((prevItems) => prevItems.filter((_, i) => i !== index));
                    }}
                >
                    <Delete />
                </SovosIconButton>
            </SovosBox>
        );
    });
};

const TranslationTableDetailsCreator = (props) => {
    const { saveTranslationDetails, pushNotification, reload } = useGlobalValue();
    const { editOpen, setEditOpen, onSaveSuccess, i18n } = props;
    const { row, status, cdmNames, message } = editOpen;
    const [conditionsParsed, setConditionsParsed] = useState(row?.conditionsParsed || []);
    const [updatesParsed, setUpdatesParsed] = useState(row?.updatesParsed || []);

    useEffect(() => {
        setConditionsParsed(row?.conditionsParsed);
        setUpdatesParsed(row?.updatesParsed);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(row)]);

    const finalResultConditions = conditionsUpdateBuild(
        conditionsParsed,
        cdmNames,
        setConditionsParsed,
    );

    const finalResultUpdates = conditionsUpdateBuild(updatesParsed, cdmNames, setUpdatesParsed);

    const handleSave = async () => {
        const result = await onTranslationTableDetailsSave(
            saveTranslationDetails,
            row?.translationTableBuilderId,
            { conditions: conditionsParsed, updates: updatesParsed },
            pushNotification,
            reload,
            row?.translationId,
            setEditOpen,
            Array.from(new Set((conditionsParsed || []).map(({ column }) => column))).join("|"),
            row?.related_entities,
        );
        
        if (result && onSaveSuccess) {
            onSaveSuccess(result);
        }
    };

    return (
        <SovosEditableDrawer
            open={status}
            onClose={() => {
                setEditOpen({ status: false });
            }}
            size={"large"}
            title={`Translation builder`}
            PrimaryButtonProps={{
                onClick: handleSave,
            }}
            SecondaryButtonProps={{
                onClick: () => setEditOpen({ status: false }),
            }}
        >
            <SovosDialogContent>
                {message && (
                    <SovosAlert severity="error" sx={{ marginBottom: "8px" }}>
                        <SovosAlertTitle>{i18n`Important`}</SovosAlertTitle>
                        {i18n`${message}`}
                    </SovosAlert>
                )}
                <SovosTypography children={`When`} variant={"h4"} />
                {finalResultConditions && finalResultConditions}
                <SovosBox sx={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                    <SovosButton
                        startIcon={<Add />}
                        size="medium"
                        variant="contained"
                        onClick={() => {
                            setConditionsParsed((prevItems) => {
                                return [
                                    ...prevItems,
                                    {
                                        value: "",
                                        column: "",
                                        operator: "=",
                                    },
                                ];
                            });
                        }}
                    >
                        Add condition
                    </SovosButton>
                </SovosBox>
                <SovosTypography children={`convert`} variant={"h4"} />
                {finalResultUpdates && finalResultUpdates}
                <SovosBox sx={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                    <SovosButton
                        startIcon={<Add />}
                        size="medium"
                        variant="contained"
                        onClick={() => {
                            setUpdatesParsed((prevItems) => {
                                return [
                                    ...prevItems,
                                    {
                                        value: "",
                                        column: "",
                                        operator: "=",
                                    },
                                ];
                            });
                        }}
                    >
                        Add condition
                    </SovosButton>
                </SovosBox>
            </SovosDialogContent>
        </SovosEditableDrawer>
    );
};

export default TranslationTableDetailsCreator;
